'use client'

import React, { createContext, useContext } from 'react'

interface KnockProviderContextType {
  isKnockInitialized: boolean
}

const KnockProviderContext = createContext<KnockProviderContextType>({
  isKnockInitialized: false,
})

export const useKnockProviderContext = () => useContext(KnockProviderContext)

export const KnockProviderContextProvider = ({
  children,
  isKnockInitialized,
}: React.PropsWithChildren<{ isKnockInitialized: boolean }>) => {
  return <KnockProviderContext.Provider value={{ isKnockInitialized }}>{children}</KnockProviderContext.Provider>
}
